import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { red } from "@mui/material/colors";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Layout from "./components/Layout";
import { AuthProvider } from "./context/AuthProvider";
import AppProvider from "./context/AppProvider";
import CustomRouter from "./navigator/CustomRouter";

// Create a theme instance.
const theme = createTheme({
  palette: {
    primary: {
      main: "#ee5e18",
    },
    secondary: {
      main: "#ee5e18",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fff",
    },
  },
  typography: {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AppProvider>
          <AuthProvider>
            {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
            <CssBaseline />
              <CustomRouter>
                <Layout />
              </CustomRouter>
          </AuthProvider>
        </AppProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
